import { Reveal } from "./primitives";
import { EXPERIENCE } from "@/data/content";

export const Experience = () => (
  <section id="experience" data-testid="experience-section" className="py-24 md:py-36">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <Reveal>
        <span className="text-xs tracking-[0.22em] uppercase font-bold text-[#e24a29]">Experience</span>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight">
          Where I&apos;ve worked.
        </h2>
      </Reveal>

      <div className="mt-14 border-l-2 border-[rgba(28,27,26,0.14)]">
        {EXPERIENCE.map((e, i) => (
          <Reveal key={e.company} delay={i * 0.12}>
            <div className="relative pl-8 md:pl-12 pb-14 last:pb-0 group">
              <span className="absolute -left-[9px] top-1.5 h-4 w-4 rounded-full bg-[#f5f3ef] border-2 border-[#e24a29] group-hover:bg-[#e24a29] transition-colors duration-300" />
              <div className="flex flex-wrap items-baseline justify-between gap-2">
                <h3 className="font-display text-2xl md:text-3xl font-bold">{e.company}</h3>
                <span className="text-sm font-semibold text-[#57534e]">{e.period}</span>
              </div>
              <p className="mt-1 text-[#e24a29] font-semibold">{e.role}</p>
              <p className="mt-3 text-[#57534e] leading-relaxed max-w-2xl">{e.note}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
